import { ICarentsTotals } from "Dashboard/scenes/Carnets/domain/ICarnetsTotals";
import React from "react";

interface IProps {
  totals: ICarentsTotals;
}

const HtzFooter = ({ totals }: IProps) => {
  return (
    <div className="row">
      <div></div>
      <div className="col center strong">
      </div>
      <div className="col center strong">
      </div>
      <div className="col center strong">
      </div>
      <div className="col center strong">
      </div>
      <div></div>
    </div>
  );
};

export default HtzFooter;
